import { createRouter, createWebHistory } from 'vue-router';
import { useAuth } from '@/stores/auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: () => import('@/views/HomeView.vue') },
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
    { path: '/register', name: 'register', component: () => import('@/views/RegisterView.vue') },
    { path: '/reset-password', name: 'reset-password', component: () => import('@/views/ResetPasswordView.vue') },
    { path: '/demo', name: 'demo-list', component: () => import('@/views/DemoListView.vue') },
    // Virtual laboratoriya labi o'zining to'liq ekranli sahifasida ochiladi
    { path: '/demo/chem-workbench', redirect: '/chemical/new' },
    {
      path: '/demo/:labId',
      name: 'demo',
      component: () => import('@/views/DemoLabView.vue'),
      props: true,
    },
    // Virtual kimyo laboratoriyasi (NOBOOK uslubi): mehmonlar uchun ham ochiq, saqlash — brauzerda yoki hisobda
    { path: '/chemical', redirect: '/chemical/new' },
    { path: '/chemical/new', name: 'chemical-new', component: () => import('@/views/ChemLabView.vue'), meta: { fullscreen: true } },
    { path: '/chemical/:id', name: 'chemical', component: () => import('@/views/ChemLabView.vue'), props: true, meta: { fullscreen: true } },
    {
      path: '/session/:id',
      name: 'session',
      component: () => import('@/views/SessionView.vue'),
      props: true,
      meta: { auth: true },
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/views/TeacherView.vue'),
      meta: { auth: true, roles: ['teacher', 'institution_admin', 'superadmin'] },
    },
    {
      path: '/teacher/assignments/:id',
      name: 'teacher-assignment',
      component: () => import('@/views/TeacherAssignmentView.vue'),
      props: true,
      meta: { auth: true, roles: ['teacher', 'institution_admin', 'superadmin'] },
    },
    {
      path: '/teacher/students/:id',
      name: 'teacher-student',
      component: () => import('@/views/TeacherStudentView.vue'),
      props: true,
      meta: { auth: true, roles: ['teacher', 'institution_admin', 'superadmin'] },
    },
    {
      path: '/teacher/sessions/:id',
      name: 'teacher-session',
      component: () => import('@/views/TeacherSessionView.vue'),
      props: true,
      meta: { auth: true, roles: ['teacher', 'institution_admin', 'superadmin'] },
    },
    {
      path: '/superadmin',
      name: 'superadmin',
      component: () => import('@/views/SuperadminView.vue'),
      meta: { auth: true, roles: ['superadmin'] },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/views/AdminView.vue'),
      meta: { auth: true, roles: ['institution_admin', 'superadmin'] },
    },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuth();
  await auth.bootstrap();
  if (to.meta.auth && !auth.isAuthenticated) return { name: 'login', query: { next: to.fullPath } };
  const roles = to.meta.roles as string[] | undefined;
  if (roles && auth.role && !roles.includes(auth.role)) return { name: 'home' };
  return true;
});
